if (wishlistJs) {
  wishlistPageInit();
}
else {
  console.log("Wishlist page js not triggered");
}
function createSrcsetImageElement(baseUrl,alt) {
  const sizes = [320, 480, 640, 750, 768, 1024, 1280,1440,1600];
  function generateSrcset(baseUrl, sizes) {
    return sizes.map(size => `${baseUrl}&width=${size/2} ${size}w`).join(', ');
  }
  // Generate the srcset attribute
  const srcset = generateSrcset(baseUrl, sizes);
  // Create the img element string
  const imgElementString = `<img srcset="${srcset}" src="${baseUrl}_640x.jpg" alt="${alt}">`;
  return imgElementString;
}
function wishlistPageInit() {
  /* Variables */
  const wishlistPageJs = document.getElementById('wishlistpagescript');
  let parsedWishlistPageJs = JSON.parse(wishlistPageJs.textContent);
  const vtn_add_to_cart_text = parsedWishlistPageJs.addToCartButtonText;
  const vtn_sold_out_text = parsedWishlistPageJs.soldOutButtonText;
  const vtn_add_to_cart_success_msg = parsedWishlistPageJs.addedToCartSuccessMessage;
  const vtn_cartUrl = parsedWishlistPageJs.cartUrl;
  const wishlistPageImageRatio = parsedWishlistPageJs.imageRatio;
  const vtnAllSoldOutText = parsedWishlistPageJs.allSoldOutText;
  const vtnEnableMoveToCart = parsedWishlistPageJs.enableMoveToCart;
  const vtnBulkAddToCartText = parsedWishlistPageJs.bulkAddToCartText;
  const vtnGuestCustomerMessage = parsedWishlistPageJs.guestCustomerMessage;
  const vtnHideVendor = parsedWishlistPageJs.hideVendor;
  const wishlistContainer = document.querySelector('.wishlist-display');
  let loggedStatus = false;
  if (typeof vtnCustomerId !== 'undefined' && vtnCustomerId !== '' && vtnCustomerId !== null) {
    loggedStatus = true;
  }
  let bulkfeature = false;
  if (vtnBulkAddToCartText !== '') {
    bulkfeature = true;
  }
  /* Variant selection */
  const productVariantHtml = (variants, selectedVariantId) => {
    let variantsLength = variants.edges.length;
    let firstVariantTitle = variants.edges[0].node.title;
    let hiddenClass = '';
    if (variantsLength === 1 && firstVariantTitle === 'Default Title') {
      hiddenClass = 'select-hide';
    }
    let options = `<select class="variantoptions ${hiddenClass} ${vtn_add_to_cart_text === '' && 'hide_form'}">`;
    let variantImage = '';
    let selectedVariantPrice = '';
    let selectedVariantComparePrice = '';
    let selectedVariantDiscount = '';
    let selectedVariantAvailable = false;
    variants.edges.forEach(item => {
      let variantId = item.node.id.split('/').pop();
      let comparePrice = item.node.compareAtPrice !== null ? item.node.compareAtPrice.amount + ' ' + item.node.compareAtPrice.currencyCode : '';
      if (variantId === selectedVariantId) {
        if (item.node.image !== null && item.node.image.url) { variantImage = item.node.image.url; }
        if(item.node.price.currencyCode === 'EUR') {item.node.price.currencyCode = '€';}
        if(item.node.compareAtPrice !== null && item.node.compareAtPrice.currencyCode === 'EUR') {item.node.compareAtPrice.currencyCode = '€';}
        selectedVariantPrice = item.node.price.currencyCode + '' + Number(item.node.price.amount).toFixed(2);
        selectedVariantComparePrice = item.node.compareAtPrice !== null ? item.node.compareAtPrice.currencyCode + '' + Number(item.node.compareAtPrice.amount).toFixed(2) : '';
        selectedVariantDiscount = item.node.compareAtPrice !== null ? Math.round((1 - (item.node.price.amount / item.node.compareAtPrice.amount)) * 100) + '%' : '';
        selectedVariantAvailable = item.node.availableForSale;
      }
      options += `<option var-id="${variantId}" value="${item.node.title}" data-price="${item.node.price.amount} ${item.node.price.currencyCode}" data-compareprice="${comparePrice}" data-available="${item.node.availableForSale}" ${variantId === selectedVariantId ? 'selected="selected"' : ''} data-image="${variantImage}">${item.node.title}</option>`;
    })
    options += '</select>';
    return { options, variantImage, selectedVariantPrice, selectedVariantComparePrice, selectedVariantDiscount, selectedVariantAvailable }
  }
  /* Variant pricing */
  const productPriceHtml = (product, selectedVariantId) => {
    let price = `${vtWishlistText.price} <span class="price">${product.priceRange.minVariantPrice.amount} ${product.priceRange.minVariantPrice.currencyCode}</span>`;
    if (selectedVariantId && selectedVariantId !== '') {

      let variantHtml = productVariantHtml(product.variants, selectedVariantId);

      price = `<span class="price">${variantHtml.selectedVariantPrice}</span> 
              ${variantHtml.selectedVariantComparePrice !== ''
          ? `<span class="compare-at-price">${variantHtml.selectedVariantComparePrice}</span> 
                <span class="price-label price-label--sale">${variantHtml.selectedVariantDiscount}</span>  `
          : ''
        }`;
    }
    return price;
  }
  /* Wishlist remove button */
  const productRemoveHtml = (product, selectedVariantId, selectedProductId) => {
    let removeIcon = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
          <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
          </svg>`
    let removeHtml = `<div class="remove-wishlist" data-variant="${selectedVariantId}" data-product="${selectedProductId}" data-product-url="${product.handle}">` + removeIcon + `</div>`;
    return removeHtml;
  }
  /* Product form print only. For add to cart */
  const productFormHtml = (product, selectedVariantId, selectedProductId, i, currentAvailable) => {
    // console.log('currentAvailable', currentAvailable);
    let formHtml = `<form method="post" action="/cart/add" id="wishlist-add-product-${i}" accept-charset="UTF-8" class="form ${vtn_add_to_cart_text === '' && 'hide_form'}" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
          <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="id" value="${selectedVariantId}" class="product-variant-id">
          <input type="hidden" name="properties[_vtWishlist]" value="true">
          <button id="wishlist-add-product-${i}-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="wishlist-add-product-${i}-submit" ${!currentAvailable ? 'disabled="disabled"' : ''}>
              <span class="add-to-cart-message">${currentAvailable ? vtn_add_to_cart_text : vtn_sold_out_text}</span>
              <div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>
          </button>
          <input type="hidden" name="product-id" value="${selectedProductId}">
          <a class="view-cart-btn button--full-width" href="${vtn_cartUrl}">${vtn_add_to_cart_success_msg}</a>
          </form>`
    return formHtml;
  }
  /* Product Card */
  const productCard = (product, selectedVariantId, selectedProductId, i) => {
    if (product.featuredImage !== null) {
      var image = product.featuredImage.url;
    } else {
      var image = 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=webp&v=1530129081'
    }
    let removeHtml = productRemoveHtml(product, selectedVariantId, selectedProductId);
    let productLink = `https://${vtnShopDomain}/products/${product.handle}`;
    if (selectedVariantId !== '') {
      productLink = `https://${vtnShopDomain}/products/${product.handle}?variant=${selectedVariantId}`;
    }
    let variantHtml = "";
    let currentVariantImageSrc = "";
    let currentAvailable = false;
    if (product.variants) {
      variantHtml = productVariantHtml(product.variants, selectedVariantId).options;
      if (productVariantHtml(product.variants, selectedVariantId).variantImage !== '') {
        currentVariantImageSrc = productVariantHtml(product.variants, selectedVariantId).variantImage;
      }
      currentAvailable = productVariantHtml(product.variants, selectedVariantId).selectedVariantAvailable;
    }

    let priceHtml = productPriceHtml(product, selectedVariantId);
    let formHtml = productFormHtml(product, selectedVariantId, selectedProductId, i, currentAvailable);
    let imgSrc = currentVariantImageSrc !== '' && currentVariantImageSrc !== null ? currentVariantImageSrc : image;
    let srcsetImg = createSrcsetImageElement(imgSrc,product.title);
    let psimported = product.tags.includes('prestashop_imported') ? 'ps-imported' : '';
    const productHtml = `
          <w-product-card>
              <div class="w-product-card">
                  ${removeHtml}
                  <a href="${productLink}">
                      <div class="image image-${wishlistPageImageRatio} ${psimported}">${srcsetImg}</div>
                  </a>
                  <div class="product-details">
                   <a href="${productLink}">
                  ${vtnHideVendor ? '' : `<div class="vendor">${product.vendor}</div>`}
                      <div class="product-title">${product.title.charAt(0) + product.title.substring(1).toLowerCase()}</div>
                      <div class="price-container">${priceHtml}</div>
                      </a>
                      ${variantHtml ? variantHtml : null}
                      ${formHtml ? formHtml : null}
                      
                  </div>
              </div>
          </w-product-card>`
    return productHtml
  }

  /* Wishlist product fetch and display */
  const fetchDisplay = async (fetchDisplayData) => {
    fetchDisplayData = fetchDisplayData.reverse();
    if (fetchDisplayData !== null || fetchDisplayData.length > 0) {
      wishlistContainer.innerHTML = `${loggedStatus ? '' : `<p>${vtnGuestCustomerMessage}</p>`}<div class="wishlist-row-first ${bulkfeature ? '' : 'bulk-hide'}"><div class="bulk-wishlist-to-cart">${vtnBulkAddToCartText}</div></div><div class="vt-wishlist-product-grid"></div>`
      let wishlistInner = document.querySelector('.vt-wishlist-product-grid');

      for (const [index, data] of fetchDisplayData.entries()) {
        try {
          let pdDatatt = await queryFunction(data, vtnEndpoint, vtnStorefrontAccessToken, vtnCache);
          let selectedVariantId = data.wpdvi;
          let selectedProductId = data.wpdi;
          let productHtml = productCard(pdDatatt, selectedVariantId, selectedProductId, index);
          wishlistInner.insertAdjacentHTML('beforeend', productHtml);
          addToCartFromWishlist(index);
          removeFromWishlist('wishlistpage');
        } catch (error) {
          let dataArray = JSON.parse(localStorage.getItem("wishlist"));
          let note = "Error in productCard loading"
          logErrors(dataArray, note);
        }
      }
      variantChange();
      bulkAdd();
    } else {
      displayEmptyWishlistMessage(wishlistContainer);
    }
  }

  /* Bulk add to cart */
  const bulkAdd = () => {
    let bulkAddButton = document.querySelector('.bulk-wishlist-to-cart');
    bulkAddButton.addEventListener('click', function (e) {
      e.preventDefault();
      let toBeAddedCount = 0;
      let formAllData = [];
      let eachCard = document.querySelectorAll('w-product-card');
      eachCard.forEach((card) => {
        let formId = card.querySelector('form').querySelector('input[name="id"]').value;
        let formStatus = card.querySelector('form').querySelector('button').hasAttribute('disabled');
        if (!formStatus) {
          toBeAddedCount++;
          formAllData.push({ id: formId, quantity: 1, properties: { '_vtWishlist': true } });
          if (vtnEnableMoveToCart === true) {
            card.style.display = 'none';
            let localData = getLocalStorageData();
            let wishlistData = JSON.parse(localData);
            wishlistData = wishlistData.filter((item) => item.wpdvi !== formId);
            localStorage.setItem('wishlist', JSON.stringify(wishlistData));
          }
        }
      });
      const wishlistRequestBody = {
        items: formAllData,
      };
      // Add products to cart
      if (toBeAddedCount > 0) {
        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(wishlistRequestBody),
        })
          .then(response => {
            if (JSON.parse(getLocalStorageData()).length === 0) {
              displayEmptyWishlistMessage(wishlistContainer);
            }
            updateCount();
            cartCountUpdate();
            dawnDrawer(true);
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      } else {
        alert(vtnAllSoldOutText);
      }
    })
  }

  /* Single Add to cart */
  const addToCartFromWishlist = (index) => {
    let addToCartbuttons = document.querySelectorAll('.quick-add__submit');
    let i = addToCartbuttons[index];
    i.addEventListener('click', function (e) {
      e.preventDefault();

      i.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      let addToCartForm = i.closest('form[data-type="add-to-cart-form"]');
      let formData = new FormData(addToCartForm);
      let variantID = addToCartForm.querySelector('input[name="id"]').value;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => {
          if (vtnEnableMoveToCart === true) {
            i.closest('w-product-card').style.display = 'none';
            let localData = getLocalStorageData();
            let wishlistData = JSON.parse(localData);
            wishlistData = wishlistData.filter((item) => item.wpdvi !== variantID);
            localStorage.setItem('wishlist', JSON.stringify(wishlistData));
          } else {
            i.querySelector('.loading-overlay__spinner').classList.add('hidden');
            addToCartForm.querySelector('.view-cart-btn').style.zIndex = "1";
            addToCartForm.querySelector('.view-cart-btn').style.opacity = "1";
            i.style.zIndex = "-1";
            // i.querySelector('.add-to-cart-message').textContent = vtn_add_to_cart_success_msg;
            // setTimeout( function(){
            //     i.querySelector('.add-to-cart-message').textContent = vtn_add_to_cart_text;
            // }, 1000)
          }
          if (JSON.parse(getLocalStorageData()).length === 0) {
            displayEmptyWishlistMessage(wishlistContainer);
          }
          dispatchvtWishCustomEvent('vtWishlistAddtoCart', variantID);
          try {
            updateCount();
            cartCountUpdate();
            dawnDrawer();
          }
          catch (e) {
            console.log("wish cart update issue");
          }

          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
          i.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    })
  }

  //Check variant changes
  const variantChange = () => {
    let variantselectors = document.querySelectorAll('select.variantoptions');
    variantselectors.forEach(function (i) {
      i.addEventListener('change', function (e) {
        e.preventDefault();
        let newVarId = i.options[i.selectedIndex].getAttribute('var-id');
        let newVarAvailability = i.options[i.selectedIndex].getAttribute('data-available');
        let currentParent = i.closest('.product-details');
        currentParent.querySelector('input[name="id"]').value = newVarId;
        let price = i.options[i.selectedIndex].getAttribute('data-price');
        let cPrice = i.options[i.selectedIndex].getAttribute('data-compareprice');
        currentParent.querySelector('.price-container').innerHTML = `<span class="price">${price}</span> ${cPrice !== '' ? `<span class="compare-at-price">${cPrice}</span>` : ''}`;
        if (i.options[i.selectedIndex].getAttribute('data-image')) {
          currentParent.closest('.w-product-card').querySelector('img').setAttribute('src', i.options[i.selectedIndex].getAttribute('data-image'));
        }
        if (newVarAvailability === 'true') {
          currentParent.querySelector('button').removeAttribute("disabled");
          currentParent.querySelector('.add-to-cart-message').textContent = vtn_add_to_cart_text;
        } else {
          currentParent.querySelector('button').setAttribute("disabled", "disabled");
          currentParent.querySelector('.add-to-cart-message').textContent = vtn_sold_out_text;
        }
        currentParent.querySelector('.view-cart-btn').style.zIndex = "-1";
        currentParent.querySelector('button').style.zIndex = "1";
      })
    })
  }

  /* Graphql Query for products  */
  async function queryFunction(product, vtnEndpoint, vtnStorefrontAccessToken, vtnCache) {
    let pdId = product.wpdi;

    const query = `query getProductsAndVariants {
                    product(id: "gid://shopify/Product/${pdId}"){
                        title
                        handle
                        vendor
                        tags
                        featuredImage{
                            url
                        }
                        options {
                            id
                            name
                            values
                        }
                        priceRange {
                            minVariantPrice {
                                amount
                                currencyCode
                            }
                        }
                        variants(first:100){
                            edges{
                                node{
                                    id
                                    title
                                    price{
                                        amount
                                        currencyCode
                                    }
                                    compareAtPrice{
                                        amount
                                        currencyCode
                                    }
                                    availableForSale
                                    image {
                                        url
                                    }
                                }
                            }
                        }
                    }
            }`;

    try {
      const result = await fetch(vtnEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': vtnStorefrontAccessToken,
        },
        body: JSON.stringify({
          ...(query && { query }),
        }),
        vtnCache,
      });

      const body = await result.json();
      return body.data.product;

    } catch (e) {
      console.log(e.message);
    }
  }


  /* Local storage sync */

  /* Jasmeet needs to review this line of code. */
  if (window.vtWishlist.generalSettings.hide_wishlistPage) {
    wishlistContainer.innerHTML = `<p>${vtWishlistText.emptyWishlistPageGuestMessage}</p>`;
  } else {
    let localData = getLocalStorageData();
    let wishlistData = JSON.parse(localData);
    if (localData !== null && wishlistData.length > 0) {
      wishlistData = wishlistData.filter((item) => item.wpdi !== "");
      localStorage.setItem('wishlist', JSON.stringify(wishlistData));
      fetchDisplay(wishlistData);
    } else {
      displayEmptyWishlistMessage(wishlistContainer);
    }
  }

  function cartCountUpdate() {
    let cartIconBubble = document.querySelector('#cart-icon-bubble');
    if (!cartIconBubble) {
      return;
    }

    fetch(`/cart?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((responseText) => {
        let respnseHtml = new DOMParser().parseFromString(responseText, 'text/html');
        let sourceHtml = respnseHtml.querySelector('#shopify-section-cart-icon-bubble');
        document.querySelector('#cart-icon-bubble').innerHTML = sourceHtml.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }
  function dawnDrawer(returnCart) {
    let vtCartItemsElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    let vtCartDrawerElement = document.querySelector('cart-drawer');
    if (!vtCartDrawerElement && returnCart) {
      window.location.href = "/cart";
    }
    if (!vtCartDrawerElement) {
      return;
    }
    if (typeof vtCartDrawerElement.setHeaderCartIconAccessibility === 'function') {
      vtCartDrawerElement.setHeaderCartIconAccessibility();
    }

    if (typeof vtCartDrawerElement.open === 'function') {
      vtCartDrawerElement.open();
      if (vtCartDrawerElement.classList.contains('is-empty')) {
        vtCartDrawerElement.classList.remove('is-empty');
        if (vtCartDrawerElement.querySelector('.drawer__inner')) {
          vtCartDrawerElement.querySelector('.drawer__inner').classList.contains('is-empty') &&
            vtCartDrawerElement.querySelector('.drawer__inner').classList.remove('is-empty')
        }
        if (vtCartDrawerElement.querySelector('.drawer__inner-empty')) {
          vtCartDrawerElement.querySelector('.drawer__inner-empty').style.display = 'none';
        }
      }
    }
    if (vtCartItemsElement && typeof vtCartItemsElement.onCartUpdate === 'function') {
      vtCartItemsElement.onCartUpdate();
    }
    if (typeof cartItemsLoop === 'function') {
      cartItemsLoop();
    }
  }
}